const staticData = {
  hero: {
    mainLine: "Learn and Earn Rare NFT in Metaverse",
    followLine:
      "The Innovative Solana Metaverse Reforming Vedic Education via blockchain",
  },
  qAndA: {
    metaKul: {
      q: "What is Metakul? ",
      a: "Meta-kul is a metaverse based nft project which aims to spread awareness on blockchain WEB 3.0, NFT's, etc and we want our educational system to be changed. Reforming the vedic education system in Metaverse where every students will be treated equally and can work on there special talent and polish them.",
    },
    nft: {
      q: "What is NFT? ",
        a: " An NFT is a digital asset that represents real-world objects like art, music, in-game items and videos. They are bought and sold online, frequently with cryptocurrency.",
    },
    blockChain: {
        q: "What can you do Metakul NFT you own? ",
          a: "1.You can sell it for a profit or hold it to earn $KULL token to use for breeding or in-game.",
      },
  },
};
export default staticData;
